/* prettier-ignore */

import { Component, computed, inject, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';

@Component({
  selector: 'map-add-confirm',
  imports: [CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './add-confirm.component.html',
  styleUrls: ['./add-confirm.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})

export class AddConfirmComponent {
    private routeService = inject(NewCustomRouteService)
    public itemToAdd = computed(() => this.routeService.itemToAdd())
    public translate = inject(TranslateService);

    cancel(){
      this.routeService.disableTouch.set(false)
      this.routeService.cancelItemToAdd();
    }

    confirm(){
      this.routeService.disableTouch.set(false)
      this.routeService.addItem();
    }

}